import dynamic from 'next/dynamic';

import { FloatCardsWrapper } from 'components/wrappers/FloatCardsWrapper';

import { MessageSent } from './containers/MessageSent';
import { useSubmit } from './useSubmit';

import backgroundImage from '/public/images/home/get-in-touch.png';

const GetInTouchForm = dynamic(
  async () => {
    const mod = await import('./containers/GetInTouchForm');

    return mod.GetInTouchForm;
  },
  { ssr: false },
);

export const GetInTouch: React.FC = () => {
  const formHandler = useSubmit();

  return (
    <FloatCardsWrapper id="request_a_demo" image={backgroundImage} reverse>
      {formHandler.sent ? (
        <MessageSent />
      ) : (
        <GetInTouchForm formHandler={formHandler} />
      )}
    </FloatCardsWrapper>
  );
};
